import { SlidersHorizontal, Download, Loader2 } from 'lucide-react'
import { Button } from '@/components/ui/button'

interface PageHeaderProps {
  title: string
  titlePrefix?: React.ReactNode
  description?: string
  onToggleFilter?: () => void
  onExport?: () => void
  isExporting?: boolean
  isLoading?: boolean
  disabled?: boolean
  children?: React.ReactNode
}

export function PageHeader({
  title,
  titlePrefix,
  description,
  onToggleFilter,
  onExport,
  isExporting,
  disabled,
  isLoading,
  children,
}: PageHeaderProps) {
  return (
    <div className="flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between pb-2">
      <div className="flex flex-1 items-center gap-2 min-w-0">
        {titlePrefix && <div className="shrink-0">{titlePrefix}</div>}
        <div className="min-w-0 flex-1">
          <h1
            className="text-[20px] font-bold text-gray-900 truncate"
            title={title}
          >
            {title}
          </h1>
          {description && (
            <p
              className="text-[#A9AFB7] p-0 m-0 mt-1 truncate"
              title={description}
            >
              {description}
            </p>
          )}
        </div>
      </div>

      {!isLoading && (
        <div className="flex w-full shrink-0 flex-wrap items-center gap-2 sm:w-auto">
          {children}

          {onExport && (
            <Button
              variant="outline"
              size="md"
              disabled={isExporting || disabled}
              className="flex-1 gap-2 sm:flex-none h-10 border-[#CE7A58] text-[#CE7A58] hover:bg-[#d96a3a]/10"
              onClick={onExport}
            >
              {isExporting ? (
                <Loader2 size={16} className="animate-spin" />
              ) : (
                <Download size={16} />
              )}
              {isExporting ? 'Đang xuất...' : 'Xuất dữ liệu'}
            </Button>
          )}

          {onToggleFilter && (
            <Button
              variant="outline"
              size="md"
              className="flex-1 gap-2 sm:flex-none h-10"
              onClick={onToggleFilter}
            >
              <SlidersHorizontal size={16} />
              Bộ lọc
            </Button>
          )}
        </div>
      )}
    </div>
  )
}
